import {
  pure,
  renderComponent,
  branch,
  compose
} from 'recompose'
import Select from './Select.jsx'
import FieldWrapper from './FieldWrapper.jsx'

export default compose(
  branch(props => props.formComponent, renderComponent(FieldWrapper)),
  pure
)(Select)



// WEBPACK FOOTER //
// ./components/uiLib/Select/index.js